<template>
  <div>
    <drivers-list
      :is-blocked-state="true"
      initial-fetch-list
    />
  </div>
</template>

<script>
import DriversList from './drivers-list/DriversList.vue'

export default {
  components: {
    DriversList,
  },
}
</script>

<style>

</style>
